import { z } from 'zod';
import { registry } from '../registry';
export const baseLastBowelMovement = z
    .object({
    wnl: z.boolean().optional().register(registry, { label: 'WNL' }),
    lastBowelMovement: z.string().optional().register(registry, { label: 'Date' }),
    stoolConsistency: z
        .string()
        .optional()
        .register(registry, {
        label: 'Consistency',
        options: [
            { value: 'formed', label: 'Formed' },
            { value: 'soft', label: 'Soft' },
            { value: 'loose', label: 'Loose' },
            { value: 'liquid', label: 'Liquid' },
            { value: 'hard', label: 'Hard' },
        ],
    }),
    stoolColor: z
        .string()
        .optional()
        .register(registry, {
        label: 'Color',
        options: [
            { value: 'brown', label: 'Brown' },
            { value: 'yellow', label: 'Yellow' },
            { value: 'green', label: 'Green' },
            { value: 'blackTarry', label: 'Black / Tarry' },
            { value: 'bloody', label: 'Bloody' },
            { value: 'clay', label: 'Clay' },
        ],
    }),
    stoolAmount: z
        .string()
        .optional()
        .register(registry, {
        label: 'Amount',
        options: [
            { value: 'small', label: 'Small' },
            { value: 'moderate', label: 'Moderate' },
            { value: 'large', label: 'Large' },
        ],
    }),
})
    .register(registry, { label: 'Last Bowel Movement' });
export const baseLastBowelMovementRefined = baseLastBowelMovement.refine((data) => data.wnl || data.lastBowelMovement?.trim() || data.stoolConsistency?.trim() || data.stoolColor?.trim() || data.stoolAmount?.trim(), { message: 'At least one answer is required', path: [] });
